@if (attachmentLike && !hasOnlyButton && !canDropFile) {
  <rt-attachment-item
    [attachment]="attachmentLike"
    [hasDownloadAction]="downloadable"
    [hasSetAsCvAction]="canManageCandidates"
    [hasDeleteAction]="true"
    (deleteClick)="clearValue()"
    margin-bottom-small
    small
  >
  </rt-attachment-item>
}

<div layout-horizontal>
  <input
    #fileInput
    [accept]="accept"
    (change)="onFileChange(fileInput.files)"
    (blur)="blur.emit(undefined)"
    type="file"
    hidden
  />
  @if (!canDropFile) {
    @if (!buttonPrimary) {
      <rt-button
        [disabled]="disabled"
        [loading]="loadingButton"
        (click)="fileInput.click()"
        variant="tertiary"
      >
        @if (withIcon) {
          <rt-icon name="file-upload"></rt-icon>
        }
        <span>{{ buttonText }}</span>
      </rt-button>
    }
    @if (buttonPrimary) {
      <rt-button
        [disabled]="disabled"
        [loading]="loadingButton"
        (click)="fileInput.click()"
        variant="primary"
      >
        @if (withIcon) {
          <rt-icon name="file-upload"></rt-icon>
        }
        <span>{{ buttonText }}</span>
      </rt-button>
    }
  } @else {
    @if (dropAreaVisible) {
      <div
        (dragleave)="switchDropArea(false)"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
        class="drop-area-content"
        layout-centered-x
        layout-align-items-center
      >
        <div class="drop-area-container">
          <rt-icon size="large" name="cloud-upload"> </rt-icon>
          <rt-heading variant="heading large">
            {{ 'rtu.file_upload.drop_area' | translate }}
          </rt-heading>
        </div>
      </div>
    }

    <div
      (dragenter)="switchDropArea(true)"
      [class]="attachmentLike ? 'uploaded' : 'import-container'"
      layout-centered-y
      layout-full-width
    >
      @if (!attachmentLike) {
        <div layout-vertical margin-tb-large>
          <span class="file-upload" layout-centered-x layout-align-items-center>
            <rt-button
              [disabled]="disabled"
              (click)="fileInput.click()"
              variant="plain"
              padding-right-small-xx
              size="small"
            >
              {{ buttonText }}
            </rt-button>
            <span>{{ 'rtu.file_upload.or_drag_drop' | translate }}</span>
          </span>
          <span text-center>{{ extensionsText }}</span>
        </div>
      }

      @if (attachmentLike) {
        <div layout layout-space-between layout-full-width padding-lr>
          <div class="file-info" layout-centered-y>
            <rt-icon name="file-account" size="large" margin-right-small></rt-icon>
            <rt-truncate margin-right-small>{{ attachmentLike.filename }}</rt-truncate>
            <rt-icon name="check"></rt-icon>
          </div>
          <div class="actions" layout-centered-y>
            <rt-button
              [disabled]="disabled"
              (click)="fileInput.click()"
              variant="tertiary"
              margin-right-small-x
              >{{ buttonText }}</rt-button
            >
            <rt-icon-button
              (click)="clearValue()"
              variant="tertiary"
              iconName="delete"
              shape="square"
              class="danger-on-hover"
            >
            </rt-icon-button>
          </div>
          <rt-icon-button
            #moreDropdownTrigger="rtOverlayOrigin"
            (click)="switchDropdown(true)"
            [pressed]="moreDropdownOpened"
            class="more"
            rt-overlay-origin
            variant="tertiary"
            iconName="more-horiz"
            shape="square"
          ></rt-icon-button>
          <ng-template
            #moreDropdown="rtConnectedOverlay"
            [origin]="moreDropdownTrigger"
            [open]="moreDropdownOpened"
            (backdropClick)="switchDropdown(false)"
            rt-connected-overlay
            hasBackdrop
          >
            <rt-dropdown [width]="DropdownWidth.SmallX">
              <rt-dropdown-item (click)="fileInput.click()">
                <rt-icon prefix name="file-upload"></rt-icon>
                {{ buttonText }}
              </rt-dropdown-item>
              <rt-dropdown-item (click)="clearValue()">
                <rt-icon prefix name="delete"></rt-icon>
                {{ 'rtu.common.delete' | translate }}
              </rt-dropdown-item>
            </rt-dropdown>
          </ng-template>
        </div>
      }
    </div>
  }
</div>
